import React from 'react';
import classes from './BookingDetailsCardSkeleton.module.css';

export const BookingDetailsCardSkeleton = ({ fromCreatorPage = false }) => {
  return (
    <>
      <div style={{paddingTop: fromCreatorPage ? "0px" : "30px"}} className={classes.container}>
        <div className={classes.content}>
          {/* Studio Info Section */}
          <div className={classes.studioSection}>
            <div className={`${classes.skeleton} ${classes.studioImage}`}></div>
            <div className={classes.studioInfo}>
              <div className={`${classes.skeleton} ${classes.studioName}`}></div>
              <div className={`${classes.skeleton} ${classes.studioLocation}`}></div>
            </div>
          </div>

          <div className={classes.horizontalLine} />

          {/* Status Section */}
          <div className={classes.statusSection}>
            <div className={`${classes.skeleton} ${classes.statusLabel}`}></div>
            <div className={`${classes.skeleton} ${classes.statusValue}`}></div>
          </div>

          <div className={classes.horizontalLine} />

          {/* Date and Time Section */}
          <div className={classes.dateSection}>
            <div className={`${classes.skeleton} ${classes.dateLabel}`}></div>
            <div className={classes.dateInfo}>
              <div className={`${classes.skeleton} ${classes.dateValue}`}></div>
              <div className={`${classes.skeleton} ${classes.timeValue}`}></div>
              <div className={`${classes.skeleton} ${classes.durationValue}`}></div>
            </div>
            <div className={`${classes.skeleton} ${classes.exportButton}`}></div>
          </div>

          {!fromCreatorPage && (
            <>
              <div className={classes.horizontalLine} />
              
              {/* Address Section */}
              <div className={classes.addressSection}>
                <div className={`${classes.skeleton} ${classes.addressLabel}`}></div>
                <div className={`${classes.skeleton} ${classes.addressValue}`}></div>
                <div className={`${classes.skeleton} ${classes.exportButton}`}></div>
              </div>
            </>
          )}

          <div className={classes.horizontalLine} />

          {/* Participants Section */}
          <div className={classes.participantsSection}>
            <div className={`${classes.skeleton} ${classes.participantsLabel}`}></div>
            <div className={`${classes.skeleton} ${classes.participantsValue}`}></div>
          </div>
        </div>

        {/* Buttons Container */}
        {!fromCreatorPage && (
          <div className={classes.buttonsContainer}>
            <div className={`${classes.skeleton} ${classes.button}`}></div>
            <div className={`${classes.skeleton} ${classes.button}`}></div>
          </div>
        )}

        {/* Rate Button Container */}
        <div className={classes.rateButtonContainer}>
          <div className={`${classes.skeleton} ${classes.rateButton}`}></div>
        </div>
      </div>

      {/* Phone Rate Button */}
      <div className={classes.rateButtonContainerPhone}>
        <div className={`${classes.skeleton} ${classes.rateButton}`}></div>
      </div>
    </>
  );
};

export default BookingDetailsCardSkeleton; 